import React from 'react'
import { useTranslation } from 'react-i18next'

import StatTilesCard from './StatTilesCard'
import { ModuleAudience } from '../types'

type ModuleAudienceCardProps = {
  description: string
  audience: ModuleAudience | null | undefined
  loading: boolean
  hasError: boolean
  viewsLabel?: string
}

const ModuleAudienceCard: React.FC<ModuleAudienceCardProps> = ({ description, audience, loading, hasError, viewsLabel }) => {
  const { t } = useTranslation()

  return (
    <StatTilesCard
      title={t('stats.product_analytics.module_audience.title')}
      description={description}
      loading={loading}
      hasError={hasError}
      tiles={[
        { key: 'sessions', label: t('stats.product_analytics.module_audience.sessions'), value: audience?.sessions },
        {
          key: 'sessionShare',
          label: t('stats.product_analytics.module_audience.session_share'),
          value: audience?.sessionShare,
          suffix: ' %',
        },
        {
          key: 'pageViews',
          label: viewsLabel ?? t('stats.product_analytics.module_audience.page_views'),
          value: audience?.pageViews,
        },
      ]}
    />
  )
}

export default ModuleAudienceCard
